<header class="d-print-none">
  <backstage-site-header chatbot="true" fluid="fluid"></backstage-site-header>
</header>
<main class="flex-grow-1">
  <backstage-notifications [connect]="true"></backstage-notifications>
  <router-outlet></router-outlet>
</main>
<footer class="d-print-none">
  <backstage-site-footer fluid="fluid"></backstage-site-footer>
</footer>
